import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import BentoFeatures from "../components/BentoFeatures";
import VideoSection from "../components/VideoSection";
import MarqueeSection from "../components/MarqueeSection";
import CTAFooter from "../components/CTAFooter";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#FFFBEB]" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <BentoFeatures />
      <VideoSection />
      <MarqueeSection />
      <CTAFooter />
    </div>
  );
}
